// Contratos: la ruta /contratos y sus datos siguen intactos; solo se ocultan los accesos y se anuncian como «próximamente».
export const CONTRATOS_VISIBLE = false;
export const proximamente = (texto, etiqueta = "Próximamente") => (CONTRATOS_VISIBLE ? texto : `${texto} (${etiqueta})`);
